(function($) {
    var upgradeCallback = null;
    var productList = null;
    var changeList = null;
    var restartText = '';
    
    $.extend({
        showMaintenanceUpgradeDialog : function(options) {
            upgradeCallback = null;
            productList = null;
            changeList = null;
            restartText = '';
            
            if (!!options) {
                upgradeCallback = options.upgradeCallback;
                cancelCallback = options.cancelCallback;
                productList = options.productList;
                changeList = options.changeList;
                restartText = options.restartText;
            }
            
            $('#maintenanceUpgradeDialog').dialog({
                title: com.compuware.ces.availableMaintenance,
                width: 593,
                modal: true,
                draggable : false,
                resizable : false,
                buttons : {
                    "Upgrade" : {
                        text : com.compuware.ces.upgrade,
                        'class' : 'upgrade-button',
                        click : function() {
                            if (typeof upgradeCallback === 'function') {
                                upgradeCallback.call(this);
                                $(this).dialog('close');
                            } else {
                                $(this).dialog('close');
                            }
                        }
                    },
                    "Cancel" : {
                        text : cancelButtonText,
                        click : function() {
                            if (typeof cancelCallback === 'function') {
                                cancelCallback.call(this);
                                $(this).dialog('close');
                            } else {
                                $(this).dialog('close');
                            }
                        }
                    }
                },
                open: function(event, ui) {
                    if (!!productList) {
                        var templateData = [];
                        
                        for (var productIndex = 0; productIndex < productList.length; productIndex++) {
                            var product = productList[productIndex];
                            
                            if (!!product.changeinfo) {
                                var productInfo = {product : product.name, version : product.upgradedVersion, changes : []};
                                
                                for (var index = 0; index < product.changeinfo.length; index++) {
                                    //TODO: once the changes are grouped by product we'll need to push just the changes that match the product.
                                    productInfo.changes.push({change : product.changeinfo[index]});
                                }
                                
                                templateData.push(productInfo);
                            }
                        }
                        
                        if (templateData.length > 0) {
                            $('#changeWrapper').show();
                            $('#changeList').html(Mustache.to_html($('#changesTemplate').html().trim(), {products : templateData}));
                        }
                    }
                    
                    $('#restartNote').html(restartText);
                    $(this).dialog('option', 'position', {my: 'center', at: 'center', of: window});
                },
                close: function(event, ui) {
                    $('#changeWrapper').hide();
                    $('#restartNote').html('');
                }
            });
        }
    });
})(jQuery);